import axios from "../utils/axios";
export default async (params) => {
  const result = await axios(params)
  return result.data ? result.data : result
}